import { Controller } from "@hotwired/stimulus"

// Riquadro e Mostra di components/Riquadro.js. Riquadro: aperto all'inizio in «Completa», oppure con cose da fare
// (daFare > 0) o `aperto`; Mostra: aperto in «Completa», chiuso in «Semplice». Il clic apre e chiude; quando cambia la
// modalità (evento "modalita:cambiata" di modalita_controller) e con essa la partenza, si torna alla partenza.
// Una parte della pagina riletta con morph (risposta di una scrittura, frame ricaricato) non cambia aperto/chiuso:
// come lo stato di React dopo load(), il riquadro resta come l'ha lasciato chi guarda (turbo:before-morph-attribute
// sull'elemento, sul pulsante, sul pannello e sulle icone; il pulsante di Mostra non si riscrive).
export default class extends Controller {
  static targets = ["pulsante", "pannello", "iconaAperta", "iconaChiusa"]
  static values = {
    mostra: Boolean, semplice: Boolean, daFare: Number, aperto: Boolean,
    etichetta: String, etichettaChiudi: { type: String, default: "Nascondi" },
  }

  connect() {
    this.onModalita = this.onModalita.bind(this)
    window.addEventListener("modalita:cambiata", this.onModalita)
    this.partenzaCorrente = this.partenza()
    this.open = !this.pannelloTarget.hidden
    this.onMorphAttributo = this.onMorphAttributo.bind(this)
    this.onMorphElemento = this.onMorphElemento.bind(this)
    this.element.addEventListener("turbo:before-morph-attribute", this.onMorphAttributo)
    this.element.addEventListener("turbo:before-morph-element", this.onMorphElemento)
  }

  disconnect() {
    window.removeEventListener("modalita:cambiata", this.onModalita)
    this.element.removeEventListener("turbo:before-morph-attribute", this.onMorphAttributo)
    this.element.removeEventListener("turbo:before-morph-element", this.onMorphElemento)
  }

  // gli attributi che dicono aperto/chiuso restano quelli della pagina (non di un riquadro annidato)
  onMorphAttributo(event) {
    const t = event.target
    if (t.closest("[data-controller~='riquadro']") !== this.element) return
    const nome = event.detail.attributeName
    const icone = this.mostraValue ? [] : [this.iconaApertaTarget, this.iconaChiusaTarget]
    if ((t === this.element && nome === "data-aperto") || (t === this.pulsanteTarget && nome === "aria-expanded") ||
        ((t === this.pannelloTarget || icone.includes(t)) && nome === "hidden")) event.preventDefault()
  }

  // Mostra: l'etichetta del pulsante («Mostra …» / «Nascondi …») segue lo stato, non il server
  onMorphElemento(event) {
    if (this.mostraValue && event.target === this.pulsanteTarget) event.preventDefault()
  }

  partenza() {
    if (this.mostraValue) return !this.sempliceValue
    return !this.sempliceValue || this.apertoValue || this.daFareValue > 0
  }

  onModalita(event) {
    const m = event.detail?.modalita || document.body.dataset.modalita
    this.sempliceValue = m === "semplice"
    const p = this.partenza()
    if (p === this.partenzaCorrente) return
    this.partenzaCorrente = p
    this.mostraStato(p)
  }

  toggle() {
    this.mostraStato(!this.open)
  }

  mostraStato(open) {
    this.open = open
    this.pannelloTarget.hidden = !open
    this.pulsanteTarget.setAttribute("aria-expanded", String(open))
    if (this.mostraValue) {
      this.pulsanteTarget.textContent = open ? this.etichettaChiudiValue : this.etichettaValue
    } else {
      this.element.dataset.aperto = open ? "si" : "no"
      this.iconaApertaTarget.toggleAttribute("hidden", !open)
      this.iconaChiusaTarget.toggleAttribute("hidden", open)
    }
  }
}
